export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";